import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Dialog, SharedModule } from '@vendure/admin-ui/core';

import { RedirectsDataService } from './redirects-data.service';

@Component({
  template: `
    <ng-template vdrDialogTitle
      >{{ 'redirects.create-dialog.title' | translate }}
    </ng-template>

    <form
      (ngSubmit)="onSubmit()"
      class="form-grid"
      id="create-form"
      [formGroup]="form"
    >
      <vdr-form-field label="Source" required>
        <input type="text" [formControlName]="'source'" />
      </vdr-form-field>
      <vdr-form-field label="Destination" required>
        <input type="text" [formControlName]="'destination'" />
      </vdr-form-field>
      <vdr-form-field label="Permanent input">
        <input type="checkbox" [formControlName]="'permanent'" />
      </vdr-form-field>

      <ng-template vdrDialogButtons>
        <button
          type="button"
          class="btn"
          (click)="cancel()"
          [disabled]="loading()"
        >
          {{ 'common.cancel' | translate }}
        </button>
        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="loading()"
          form="create-form"
        >
          @if (loading()) {
            <span class="btn-loading">
              <span class="spinner spinner-sm"></span>
              {{ 'common.processing' | translate }}
            </span>
          } @else {
            <span>{{ 'common.create' | translate }}</span>
          }
        </button>
      </ng-template>
    </form>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SharedModule],
})
export class RedirectCreateDialogComponent implements Dialog<boolean> {
  protected loading = signal(false);
  protected form;

  constructor(
    private redirectsDataService: RedirectsDataService,
    formBuilder: FormBuilder,
  ) {
    this.form = formBuilder.nonNullable.group({
      source: [''],
      destination: [''],
      permanent: [true],
    });
  }

  protected async onSubmit() {
    this.loading.set(true);
    const { source, destination, permanent } = this.form.getRawValue();
    const result = await this.redirectsDataService.createRedirect({
      source: this.prefixWithSlash(source),
      destination: this.prefixWithSlash(destination),
      permanent,
    });
    this.loading.set(false);
    if (result.succeeded) {
      // only close on success
      this.resolveWith(result.succeeded);
    }
  }

  cancel() {
    this.resolveWith(false);
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  resolveWith(result?: boolean): void {}

  private prefixWithSlash(path: string) {
    return path.startsWith('/') ? path : `/${path}`;
  }
}
